
/**
 * GA4
 * Gets the user access type from user email data
 * @param userEmailData - User email data containing accessCodeGA4
 * @returns The user's access type string ('fastpass', 'registration', 'passwordless', or 'NONE')
 */
export function getUserAccessCode(userEmailData: { accessCodeGA4?: string }): string {
  return userEmailData?.accessCodeGA4 ? userEmailData.accessCodeGA4 : 'NONE';
}